<template>
  <b-container>
    <template v-for="(row, i) in [firstRow, secondRow]">
      <div v-if="row === firstRow" :key="i" class="d-flex align-content-around flex-wrap">
        <b-col class="mb-3" v-for="(key, i) in row" :key="i">
          <b-link @click.prevent="checkNetworkCreateMeasure(key)">
            <b-card class="h-100">
              <div class="d-flex flex-column justify-content-around">
                <div class="position-relative align-self-center action-row">
                  <span class="icon-add_filled align-top" aria-hidden="true"></span>
                </div>
                <div class="card-title align-self-center">{{ $t('measure.types')[key] }}</div>
              </div>
            </b-card>
          </b-link>
        </b-col>
      </div>
      <div v-else-if="row === secondRow" :key="i" class="d-flex align-content-around flex-wrap">
        <b-col class="mb-3 " v-for="(key, i) in row" :key="i" >
          <b-link @click.prevent="checkNetworkCreateMeasure(key)">
            <b-card class="h-100">
              <div class="d-flex flex-column justify-content-around">
                <div class="position-relative align-self-center action-row">
                  <span class="icon-add_filled align-top" aria-hidden="true"></span>
                </div>
                <div class="card-title align-self-center">{{ $t('measure.types')[key] }}</div>
              </div>
            </b-card>
          </b-link>
        </b-col>
      </div>
    </template>
    <b-modal :id="'offLineModalMeasureCreate'" centered hide-header-close @ok="hideModal" class="network-modal">
      <template slot="modal-title">
        {{ $t('offLineModal.title') }}
      </template>
      {{ $t('offLineModal.text') }}
      <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
        <b-button size="lg" class="mt-3" @click="ok()">
          {{ $t('offLineModal.ok') }}
        </b-button>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
export default {
  name: 'MeasureCreateButtons',
  props: ['colony', 'apiary'],
  methods: {
    checkNetworkCreateMeasure (measureType) {
      if (navigator.onLine) {
        this.$router.replace('/measure/create/' + this.colony + '/' + this.apiary + '/' + measureType)
      } else {
        this.showOffLineModal()
      }
    },
    showOffLineModal () {
      this.$bvModal.show('offLineModalMeasureCreate')
    },
    hideModal () {
      this.$bvModal.hide('offLineModalMeasureCreate')
    }
  },
  computed: {
    firstRow () {
      return Object.keys(this.$t('measure.types')).slice(0, 3)
    },
    secondRow () {
      return Object.keys(this.$t('measure.types')).slice(3)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/config';

  .card-title {
    font-family: $font-family-sans-serif;
    margin-top: 1rem;
    text-align: center;
  }

  .action-row {
    font-size: 1.5rem;
    line-height: 1rem;
  }

  .card {
    background-color: $secondary-light;
  }
  .card-body {
    padding: 1rem;
  }
  .col {
    padding: 0.15rem;
  }
  @media screen and (max-width: 375px) {
    .card-title {
      font-size: 0.75rem;
    }
  }
  .network-modal {
    font-family: $font-family-sans-serif;
  }
</style>
